export default "__VITE_ASSET___yFcfhym__"